export class Empresa {
  id: string;
  codigo: string;
  nome_completo: string;
  tipo: string;
  status: string;
}